import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import * as styles from "../styles/image-link-blocks.module.scss";

const LinkBlocks = (props) => {
  return (
    <section
      className={`${styles.linkBlocks} ${
        props.background === "Off-White" ? "fog" : ""
      } ${props.half === "Half" ? styles.half : styles.third}`}
    >
      <div className="container">
        {props.titleDisplay ? (
          <header>
            <h2>{props.title}</h2>
            {props.subtitle ? <p>{props.subtitle}</p> : ""}
          </header>
        ) : (
          ""
        )}
        <div className={styles.flex}>
          {props.blocks.map((el, i) =>
            el.internalLink ? (
              <div key={el.id}>
                <GatsbyImage
                  image={el.image.gatsbyImageData}
                  alt={el.image.description}
                />
                <div className={styles.content}>
                  <h3>{el.title}</h3>
                  <p>{el.description.description}</p>
                </div>
                <Link to={el.internalLink.slug} className="buttons">
                  Discover More
                </Link>
              </div>
            ) : (
              <div key={el.id}>
                <GatsbyImage
                  image={el.image.gatsbyImageData}
                  alt={el.image.description}
                  objectFit="contain"
                />
                <div className={styles.content}>
                  <h3>{el.title}</h3>
                  <p>{el.description.description}</p>
                </div>
                <a
                  href={el.externalLink}
                  target="_blank"
                  rel="noreferrer"
                  className="buttons"
                >
                  Discover More
                </a>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default LinkBlocks;
